import { render, staticRenderFns } from "./CBSPoaTable.vue?vue&type=template&id=b5ddbe1a&"
import script from "./CBSPoaTable.vue?vue&type=script&lang=js&"
export * from "./CBSPoaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports